<div class="top-nav">
  <div class="hamburger" #hamburger>
    <span></span>
    <span></span>
    <span></span>
  </div>
  <div class="logo">
    <img src="assets/images/Logo.svg" alt="Logo" />
  </div>
  <div class="top-icons">
    <div class="search-box d-flex align-items-center px-3 py-1 bg-light">
      <i class="fas fa-search me-2 text-secondary"></i>
      <input type="text" class="form-control border-0 bg-transparent p-0" placeholder="Search in app..." />
    </div>
    <a routerLink="/login" class="text-decoration-none text-muted login" style="cursor: pointer;">
      <i class="fas fa-user me-1"></i> Login / Signup
    </a>

  </div>
</div>
<div class="d-flex">
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>